<template>
  <form @submit.prevent="confirm">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Generate New Secret?</p>
      </header>
      <section class="modal-card-body">
        <div class="has-text-centered py-lg">
          Are you sure you want to replace existing secret with a new one?
        </div>
      </section>
      <footer class="modal-card-foot space-between">
        <button class="button" type="button" @click="cancel()">Close</button>
        <b-button
          type="is-primary"
          native-type="submit"
          @click="confirm"
        >Confirm</b-button>
      </footer>
    </div>
  </form>
</template>
<script>
export default {
  methods: {
    confirm () {
      this.$emit('confirm')
      this.$parent.close()
    },
    cancel () {
      this.$emit('cancel')
      this.$parent.close()
    }
  }
}
</script>
